<template>
    <div>
        <message-controller></message-controller>
        <navbar></navbar>
        <div class="container pt-4">
            <h1 class="title">
                Materiál v garáži
                <b-icon v-if="isEditable" class="clickable" icon="plus-square-fill" variant="info"
                        @click="addNewItem()"></b-icon>
                <b-dropdown v-else id="dropdown-filter" no-caret right text="" variant="default">
                    <template v-slot:button-content="">
                        <b-icon class="clickable" icon="funnel" variant="info"></b-icon>
                    </template>
                    <label-filtration
                        @loadLabeledData="refreshLabeledData"
                        @filterData="refreshFilter"
                    ></label-filtration>
                </b-dropdown>
            </h1>
            <b-form-input
                v-model="search"
                class="search"
                placeholder="H l e d a t . . . ( název, popis, sekce )"
                type="text"
            ></b-form-input>
            
            
            <table class="table">
                <tbody>
                <template v-for="item in dataList">
                    <tr v-if="applyFilter(item)" v-bind:key="item.id"
                        v-bind:class="getItemState(item.available, item.reservations)">
                        <td>
                            <h3 class="item-wrap clickable">
                                <span @click="openModal(item.id)">{{ item.name }}<small
                                    v-if="item.section">({{ item.section }})</small>
                                    <template v-if="(item.reservations.length !== 0 && item.reservations.length !== undefined)">
                                        <small class="small-lg">
                                        <b-badge v-for="(reservation, indexx) in item.reservations" :key="indexx"
                                                 variant="warning"
                                                 pill >
                                            {{ reservation.date_start.date | moment("DD/MM") }} -
                                            {{ reservation.date_end.date | moment("DD/MM") }}
                                        </b-badge>
                                        </small>
                                        
                                    </template>
                                </span>
                                <div v-if="isEditable">
                                    <b-icon class="clickable" icon="pencil-square" variant="info"
                                            @click="openModalEdit(item.id)"></b-icon>
                                </div>
                                <div v-else class="icons">
                                    <b-icon v-if="item.available === 1"
                                            v-b-tooltip.hover icon="box-arrow-up-right"
                                            title="půjčit si"
                                            :variant="getVariant(item.reservations.length)"
                                            @click="changeLog(item.id,'take')"></b-icon>
                                    <b-icon v-if="item.allow_return === 1 && item.available !== 1"
                                            v-b-tooltip.hover icon="box-arrow-in-down-left"
                                            title="vrátit" variant="danger"
                                            @click="changeLog(item.id,'put')"></b-icon>
                                    <b-badge v-if="item.allow_return !== 1 && item.available !== 1"
                                             v-bind:href="'tel:'+item.tel_user"
                                             variant="danger">{{ item.taken_user }}
                                        <b-icon icon="phone" variant="light"></b-icon>
                                    </b-badge>
                                    
                                    
                                
                                </div>
                            </h3>
                            <span class="description">{{ item.description }}</span>
                        </td>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>
        
        
        <b-modal id="modal-garage-material-item" class="modal" hide-header>
            <div v-if="modalData" class="d-block" v-bind:class="{ 'unavailable': modalData.available !== 1 }">
                <h3 class="item-wrap">
                    <span>{{ modalData.name }}</span>
                    <div class="icons">
                        <b-icon v-if="modalData.available === 1"
                                v-b-tooltip.hover icon="box-arrow-up-right"
                                title="půjčit si" variant="info"
                                @click="changeLog(modalData.id,'take')"></b-icon>
                        <b-icon v-if="modalData.allow_return === 1 && modalData.available !== 1"
                                v-b-tooltip.hover icon="box-arrow-in-down-left"
                        
                                title="vrátit" variant="danger"
                                @click="changeLog(modalData.id,'put')"></b-icon>
                        <b-badge v-if="modalData.allow_return !== 1 && modalData.available !== 1"
                                 v-bind:href="'tel:'+modalData.tel_user"
                                 variant="danger">{{ modalData.taken_user }}
                            <b-icon icon="phone" variant="light"></b-icon>
                        </b-badge>
                    </div>
                </h3>
                
                <p class="description mt-3">{{ modalData.description }}</p>
                
                <span v-if="modalData.section">
          <label>Sekce:</label>
          {{ modalData.section }}
          <br>
        </span>
                
                
                <span v-if="modalData.birthday">
          <label>Pořízení materiálu:</label>
          <span>
            {{ modalData.birthday | moment("DD/MM/YYYY") }}
          </span>
          <br>
        </span>
                
                
                <div class="labels">
                    <label>Tagy:&nbsp;</label>
                    <b-badge v-for="label in modalData.labels" v-bind:key="label.name" class="mb-3"
                             v-bind:style="{ color: label.color, backgroundColor: label.color_bg }">
                        {{ label.name }}
                    </b-badge>
                </div>
                
                <img v-if="modalData.img_url != '' " :src="path+modalData.img_url" alt="" class="img">
                <img v-if="modalData.img_url_2 != '' " :src="path+modalData.img_url_2" alt="" class="img">
    
                <hr>
                <div v-if="arrIsEmpty(!modalData.reservations)">
                    <label class="mb-0">Rezervace:&nbsp;</label>
                    <reserve-item :reserved="modalData.reservations"
                                  :id-garage-material="modalData.id"
                                  @refresh="loadData()"
                    ></reserve-item>
                </div>
                <hr>
                <div v-if="modalData.available === 1">
                    <label>Půjčit třetí osobě</label>
                    <b-input-group class="mb-3" size="sm">
                        <b-form-input v-model="thirdPersonName"
                                      placeholder="Jméno">
                        
                        </b-form-input>
                        <b-input-group-append>
                            <b-button variant="info" @click="changeLog(modalData.id,'take')">Půjčit</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
                <b-button v-b-toggle:my-collapse size="sm" variant="info">
                    Historie výpůjček
                </b-button>
                <b-collapse id="my-collapse" class="mt-2">
                    <b-card>
                        <ul class="history_list">
                            <li v-for="(historyItem,index) in modalData.history_of_borrow"
                                v-bind:key="'history'+index"
                                v-bind:class="{ 'take': historyItem.operation == 'take' }">
                                <span>{{ historyItem.user_name.name }}<span
                                    v-if="historyItem.description != ''"> - {{ historyItem.description }}</span></span>
                                
                                <span>
                    {{ historyItem.time.date | moment("H:mm | DD/MM/YY") }}
                     <b-icon v-if="historyItem.operation == 'take'"
                             icon="box-arrow-up-right"
                             variant="danger"></b-icon>
                    <b-icon v-else
                            icon="box-arrow-in-down-left"
                            variant="info"></b-icon>
                  </span>
                            
                            </li>
                        </ul>
                    </b-card>
                </b-collapse>
            </div>
            
            <template v-slot:modal-footer="">
                <b-button block @click="$bvModal.hide('modal-garage-material-item')">Zavřít</b-button>
            </template>
        </b-modal>
        
        <b-modal v-if="isEditable" id="modal-garage-material-item-edit" class="modal" hide-header>
            <div v-if="modalData" class="d-block">
                <h3 class="item-wrap">
                
                </h3>
                <b-form-group>
                    <label>Název</label>
                    <b-form-input
                        v-model="modalData.name"
                        placeholder="Vypňte název položky"
                        type="text"
                        @change="updateModalData()"
                    ></b-form-input>
                </b-form-group>
                <b-form-group>
                    <label>Popis</label>
                    <b-form-textarea
                        v-model="modalData.description"
                        id="form-description"
                        max-rows="6"
                        placeholder="Popis položky"
                        rows="3"
                        @change="updateModalData()"
                    ></b-form-textarea>
                </b-form-group>
                
                <b-form-group v-if="modalData.birthday">
                    <label>Datum pořízení</label>
                    <b-input-group class="mb-2">
                        
                        <b-form-input
                            v-model="modalData.birthday"
                            autocomplete="off"
                            placeholder="YYYY-MM-DD"
                            type="text"
                            @change="updateModalData()"
                        ></b-form-input>
                        <b-input-group-append>
                            <b-form-datepicker
                                v-model="modalData.birthday"
                                aria-controls="example-input"
                                button-only
                                right
                                start-weekday="1"
                                @input="updateModalData()"
                            ></b-form-datepicker>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
    
                <b-form-group v-if="modalData.birthday">
                    <label class="w-100">Revize</label>
                    <template v-for="revision in modalData.revisions">
                        <b-input-group class="mb-2" :key="revision.id">
                            <b-form-input
                                v-model="revision.date"
                                autocomplete="off"
                                placeholder="YYYY-MM-DD"
                                type="text"
                                size="sm"
                                @change="updateModalData()"
                            ></b-form-input>
                            <b-input-group-append>
                                <b-form-datepicker
                                    v-model="revision.date"
                                    size="sm"
                                    aria-controls="example-input"
                                    button-only
                                    right
                                    start-weekday="1"
                                    @input="updateModalData()"
                                ></b-form-datepicker>
                            </b-input-group-append>
                            <b-button size="sm" variant="danger" @click="removeRevision(revision.id)" title="smazat">
                                <b-icon icon="trash-fill"></b-icon>
                            </b-button>
                        </b-input-group>
                    </template>
                    <b-button size="sm" variant="info" @click="addRevision()" >Přidat revizi&nbsp;
                        <b-icon icon="check2-square"></b-icon>
                    </b-button>
                </b-form-group>
                
                <b-form-group>
                    <label>Sekce</label>
                    <b-form-input
                        v-model="modalData.section"
                        placeholder="Sekce v garáži"
                        type="text"
                        @change="updateModalData()"
                    ></b-form-input>
                </b-form-group>
                
                <b-form-group>
                    <label>Tagy</label>
                    <b-form-checkbox-group
                        v-model="modalData.labels_checked"
                        :options="labels.records"
                        class="students-group"
                        name="labelsSelected"
                        size="lg"
                        text-field="name"
                        value-field="id"
                        @change="updateModalData()">
                    </b-form-checkbox-group>
                
                </b-form-group>
                
                <b-form-group>
                    <file-upload :id="modalData.id" v-on:load-data="loadData()"></file-upload>
                </b-form-group>
                
                <img v-if="modalData.img_url != '' " :src="path+modalData.img_url" alt="" class="img">
                <img v-if="modalData.img_url_2 != '' " :src="path+modalData.img_url_2" alt="" class="img">
                
                <b-form-group class="text-left mt-5">
                    <b-button size="sm" variant="danger" @click="deleteItem(modalData.id)">Smazat
                        <b-icon icon="trash-fill"></b-icon>
                    </b-button>
                </b-form-group>
            </div>
            
            <template v-slot:modal-footer="">
                <b-button block @click="$bvModal.hide('modal-garage-material-item-edit')">Zavřít</b-button>
            </template>
        </b-modal>
    
    </div>
</template>

<script>

import axios from 'axios'
import Navbar from "../components/navbar";
import MessageController from "../components/message-controller";
import LabelFiltration from "../components/label-filtration";
import FileUpload from "../components/file-upload";
import _ from 'lodash';
import ReserveItem from "@/components/reserve-item";

export default {
    name: 'garage-material',
    components: {ReserveItem, FileUpload, LabelFiltration, MessageController, Navbar},
    data() {
        return {
            path: process.env.VUE_APP_SERVER,
            user: this.$store.getters.user,
            posts: [],
            labels: [],
            modalData: {},
            filterData: [],
            filter: false,
            userEquipFilter: false,
            allUserEquipFilter: false,
            reservationFilter: false,
            errors: [],
            changedModalId: null,
            search: '',
            thirdPersonName: ''
        }
    },
    methods: {
        /**
         *
         * @param item
         * @values user_loan_equip, all_loan_equip, user_reserve_equip, all_reserve_equip
         * @returns {boolean}
         */
        applyFilter(item) {
            
            if (!this.filter) {
                return true;
            }
            
            if (this.filter == 'user_loan_equip' && (item.allow_return == 1 && item.available !== 1)) {
                return true;
            }
            
            if (this.filter == 'all_loan_equip' && item.available !== 1) {
                return true;
            }
            
            if (this.filter == 'user_reserve_equip' && item.reservations.length !== 0) {
                let result = false;
                item.reservations.forEach( (item ) => {
                    if (item.user_name.id == this.user.id) {
                        result = true;
                    }
                    
                });
                if (result) {
                    return true
                }
            }
    
            if (this.filter == 'all_reserve_equip' && item.reservations.length !== 0) {
                return true;
            }
        },
        
        async changeLog(materialItemId, operation) {
            
            const confirmText = (operation == 'take') ? 'Opravdu si chcete půjčit tuto věc?' : 'Opravdu chcete vrátit tuto věc?';
            
            if (confirm(confirmText)) {
                let data = {
                    id_garage_material: materialItemId,
                    operation: operation,
                    description: this.thirdPersonName
                };
                
                try {
                    await axios({
                        url: process.env.VUE_APP_SERVER + 'garage-material/change-log.php',
                        headers: {'content-type': 'application/x-www-form-urlencoded'},
                        data: data,
                        method: 'PUT'
                    });
                    await this.loadData();
                    this.thirdPersonName = '';
                    if (operation === 'take') {
                        this.$eventHub.$emit('openMessageController', 'success', 'Půjčeno');
                    } else {
                        this.$eventHub.$emit('openMessageController', 'success', 'Vráceno');
                        
                    }
                    
                    
                } catch (error) {
                    await this.loadData();
                    console.log("error", error);
                }
            }
            
        },
        
        async loadData() {
            try {
                const response_data = await axios({
                    url: process.env.VUE_APP_SERVER + 'garage-material/list.php',
                    headers: {'content-type': 'application/x-www-form-urlencoded'},
                    data: this.filterData,
                    method: 'POST'
                });
                
                this.posts = response_data.data;
                
                if (this.changedModalId) {
                    this.changeDataInModal(this.changedModalId);
                }
                
            } catch (error) {
                console.log("error", error);
                this.$eventHub.$emit('openMessageController', 'error', 'Žádná data');
            }
            
        },
        
        async loadLabelsData() {
            try {
                const response_data = await axios({
                    url: process.env.VUE_APP_SERVER + 'labels/list.php',
                    headers: {'content-type': 'application/x-www-form-urlencoded'},
                    method: 'GET'
                });
                
                this.labels = response_data.data;
                
            } catch (error) {
                console.log("error", error);
                this.$eventHub.$emit('openMessageController', 'error', 'Nelze načíst labely');
            }
            
        },
    
        refreshLabeledData(labelFiltrationData) {
            this.filterData = labelFiltrationData;
            this.loadData();
        },
    
        refreshFilter(filter) {
            this.filter = filter;
        },
        
        removeRevision(id) {
            this.modalData.revisions = this.modalData.revisions.filter(function( obj ) {
                return obj.id !== id;
            });
            this.updateModalData();
        },
        
        async updateModalData() {
            try {
                await axios({
                    url: process.env.VUE_APP_SERVER + 'garage-material/update-item.php',
                    headers: {'content-type': 'application/x-www-form-urlencoded'},
                    data: this.modalData,
                    method: 'PUT'
                });
                await this.loadData();
                this.$eventHub.$emit('openMessageController', 'success', 'Změna proběhla úspěšně');
                
            } catch (error) {
                console.log("error", error);
                this.$eventHub.$emit('openMessageController', 'error', 'Operace se nezdařila');
            }
            
        },
        
        async deleteItem(id) {
            try {
                if (confirm("Opravdu smazat?")) {
                    await axios({
                        url: process.env.VUE_APP_SERVER + 'garage-material/delete-item.php',
                        headers: {'content-type': 'application/x-www-form-urlencoded'},
                        data: {'id': id},
                        method: 'DELETE'
                    });
                    
                    const index = this.posts.records.findIndex(posts => posts.id === id);
                    this.posts.records.splice(index, 1);
                    
                    this.$bvModal.hide('modal-garage-material-item-edit');
                    await this.loadData();
                    this.$eventHub.$emit('openMessageController', 'success', 'Položka byla smazána');
                }
            } catch (error) {
                console.log("error", error);
                this.$eventHub.$emit('openMessageController', 'error', 'Operace se nezdařila');
            }
            
        },
        
        async addNewItem() {
            
            try {
                const response = await axios({
                    url: process.env.VUE_APP_SERVER + 'garage-material/new-item.php',
                    headers: {'content-type': 'application/x-www-form-urlencoded'},
                    method: 'POST'
                });
                
                await this.loadData();
                this.openModalEdit(response.data.id, true);
                this.$eventHub.$emit('openMessageController', 'success', 'Položka byla přidána');
                
            } catch (error) {
                console.log("error", error);
            }
            
        },
    
        async addRevision() {
            await this.updateModalData();
            try {
                await axios({
                    url: process.env.VUE_APP_SERVER + 'garage-material/add-revision.php',
                    headers: {'content-type': 'application/x-www-form-urlencoded'},
                    data: {'id': this.modalData.id},
                    method: 'POST',
                });
            
                await this.loadData();
                this.$eventHub.$emit('openMessageController', 'success', 'Položka byla přidána');
            
            } catch (error) {
                console.log("error", error);
            }
        
        },
        
        openModal(itemId) {
            this.changedModalId = itemId;
            this.$bvModal.show('modal-garage-material-item'); // open bs modal
            this.changeDataInModal(itemId);
            
        },
        openModalEdit(itemId, newItem = false) {
            this.changedModalId = itemId;
            this.$bvModal.show('modal-garage-material-item-edit'); // open bs modal
            this.loadLabelsData();
            
            if (!newItem) {
                this.changeDataInModal(itemId);
            } else {
                this.modalData = {
                    
                    studentsSelected: [],
                    
                }
            }
            
        },
        changeDataInModal(itemId) {
            try {
                this.modalData = this.posts.records.find(({id}) => id === itemId);
            } catch (err) {
                console.log(err);
            }
        },
        arrIsEmpty (arr) {
            if (arr == undefined) {
                return true;
            } else {
                if (arr.length) {
                    return false;
                } else {
                    return true;
                }
            }
            
            
        },
        getItemState(available, reservations) {
            
            if (available !== 1) {
                return 'unavailable';
            } else {
                if (reservations.length == 0){
                    return 'available';
                } else {
                    return 'reserved';
                }
            }
        },
        
        getVariant(length) {
            if(length!== 0) {
                return 'warning';
            } else { return 'info';}
        }
        
    },
    computed: {
        isEditable: function () {
            return (this.$route.params.action === 'edit' && this.$store.getters.isAdmin)
        },
        dataList: function () {
            if (this.search === '') {
                return this.posts.records;
            } else {
                /*
                const result = this.posts.records.filter(obj => Object.values(obj).some(val => val.includes(this.search)));
                console.log(result);
        
                 */
                let search = this.search.toLowerCase();
                let results = _.filter(this.posts.records, function (item) {
                    return item.search.toLowerCase().indexOf(search) > -1;
                });
                return results;
            }
        }
    },
    created() {
        this.loadData();
        this.loadLabelsData();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.table {
    max-width: 100%;
    
    th, td {
        padding-left: 0;
        padding-right: 0;
    }
}

.search {
    position: relative;
    top: 1px;
}

h3.item-wrap {
    color: var(--cyan);
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    
    small {
        display: inline-block;
        margin-left: 7px;
        font-size: 60%;
        &.small-lg {
            line-height: 100%;
            span {
                padding-bottom: 1px;
                margin-right: 3px;
                margin-bottom: 4px;
            }
        }
    }
}

.description {
    color: #6c757d;
    line-height: 100%;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    
}

.icons {
    font-size: 1.5rem;
    float: right;
    cursor: pointer;
}

.badge {
    letter-spacing: .5px;
    font-weight: 500;
    vertical-align: middle;
}

.unavailable {
    h3.item-wrap {
        color: var(--red);
    }
}

.reserved {
    h3.item-wrap {
        color: var(--warning);
    }
}

.modal {
    .unavailable {
        opacity: 1;
    }
    
    .description {
        display: block;
        overflow: visible;
        -webkit-box-orient: initial;
        line-height: 1.2;
    }
    
    .labels {
        display: inline-flex;
        min-width: 100%;
        
        label {
            padding-right: 5px;
        }
        
        .badge {
            border: 1px solid black;
            margin-right: 3px;
            
        }
    }
}

.title {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.card-body {
    overflow: auto;
    max-height: 300px;
}

.history_list {
    list-style: none;
    padding: 0;
    margin: 0;
    
    li {
        display: flex;
        justify-content: space-between;
        color: var(--cyan);
        font-weight: 600;
        
        &.take {
            color: var(--red);
        }
    }
}

.img {
    max-width: 100%;
    margin-bottom: 15px;
}
</style>
